import { render } from "./companionTeacherQuestion.vue?vue&type=template&id=2f3870b8&scoped=true"
import script from "./companionTeacherQuestion.vue?vue&type=script&lang=js"
export * from "./companionTeacherQuestion.vue?vue&type=script&lang=js"

import "./companionTeacherQuestion.vue?vue&type=style&index=0&id=2f3870b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3870b8"]])

export default __exports__